import { render, staticRenderFns } from "./wrapper-edit.vue?vue&type=template&id=1b361b17&scoped=true&"
import script from "./wrapper-edit.vue?vue&type=script&lang=js&"
export * from "./wrapper-edit.vue?vue&type=script&lang=js&"
import style0 from "./wrapper-edit.vue?vue&type=style&index=0&id=1b361b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b361b17",
  null
  
)

export default component.exports